<div [ngClass]="{ disabled: disabled }" class="label-input single-instance">
  @if (value) {
    <app-template-item
      (clear)="clear()"
      (edit)="modify.emit(value)"
      (preview)="preview.emit($event)"
      [editable]="editable"
      [deletable]="deletable"
      [active]="true"
      [disabled]="disabled"
      [hoverable]="hoverable"
    [item]="value"></app-template-item>
  } @else {
    <div [ngClass]="{ disabled: disabled }" class="default-item-container default-item-container--blue create-item-container">
      <div (click)="openDialog()" class="flex-1">
        <div class="default-item-top-container flex-row">
          <div class="default-title">{{ "template.picker.select" | translate }}</div>
        </div>
        <div class="default-item-bottom-container">
          <span class="default-subtitle">
            {{ "template.picker.selectSubtitle" | translate }}
          </span>
        </div>
      </div>
      <div (click)="modify.emit()" class="flex-1">
        <div class="default-item-top-container flex-row">
          <div class="default-title">{{ "template.picker.create" | translate }}</div>
        </div>
        <div class="default-item-bottom-container">
          <span class="default-subtitle">
            {{ "template.picker.createSubtitle" | translate }}
          </span>
        </div>
      </div>
    </div>
  }
  <ng-template #other>
    @if (!readonly && !disabled && deletable) {
      <button (click)="clear()" class="primary" type="button">
        <fa-icon icon="trash"></fa-icon>
      </button>
    }
  </ng-template>
</div>

